type MatrixObject = {
    matrixAutoUpdate?: boolean;
    updateMatrix?(): void;
    updateMatrixWorld?(force?: boolean): void;
    children?: readonly unknown[];
};

/** Rebuild a manually managed local matrix, then propagate its world transform. */
export function updateObjectMatrices(object: unknown, localTransformChanged = true): void {
    const candidate = object as MatrixObject | null | undefined;
    if (!candidate) return;
    if (localTransformChanged && candidate.matrixAutoUpdate === false) candidate.updateMatrix?.();
    candidate.updateMatrixWorld?.(true);
}

/** Rebuild every manually managed local matrix before updating the copied hierarchy. */
export function updateObjectSubtreeMatrices(root: unknown): void {
    const candidate = root as MatrixObject | null | undefined;
    if (!candidate) return;
    const rebuild = (object: MatrixObject) => {
        if (object.matrixAutoUpdate === false) object.updateMatrix?.();
        for (const child of object.children ?? []) rebuild(child as MatrixObject);
    };
    rebuild(candidate);
    candidate.updateMatrixWorld?.(true);
}
